import { Component, ChangeDetectorRef, Inject } from '@angular/core';
import { MainComponent } from '../../common/pages/main/main.component';
import { Contact } from '../../services/contact/contact.model';
import { Unit } from '../../services/unit/unit.model';
import { SettingService } from '../../common/services/setting/setting.service';
import { ContactService } from '../../services/contact/contact.service';
import { SelectService } from '../../common/services/select/select.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionService } from 'src/services/action/action.service';
import { Action } from 'src/services/action/action.model';
import { ProjectService } from 'src/services/project/project.service';
import { Project } from 'src/services/project/project.model';
import { LogsService } from 'src/common/services/logs/logs.service';
import { BrokerService } from 'src/services/broker/broker.service';
import { Broker } from 'src/services/broker/broker.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { mergeDeep } from 'functions/src/shared/tools';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent extends MainComponent {

  public item: Contact;
  public itemDuplicate: Contact;
  private ngUnsubscribeDuplicate = new Subject();

  // To Use in Units Table
  public unitModel = new Unit();

  public brokerKey: string | null = null;

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: ContactService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public backURL: BackurlService,
    public dialog: MatDialog,
    private _log: LogsService,
  ) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Contact((this.select.active && this.select.prefil) ? this.select.prefil : null, setting);
    this.itemDuplicate = new Contact((this.select.active && this.select.prefil) ? this.select.prefil : null, setting);
  }

  protected _itemOnInit(): void {
    if (!this.isRole('admin')) {
      this._log.view(
        'contacts',
        this.item.values.$key,
        { fullname: this.item.values.fullname }
      );
    }
    if (this.item.values.synaps && this.item.values.synaps.contactBroker) {
      this.brokerKey = Object.keys(this.item.values.synaps.contactBroker)[0];
    }
    if (this.item.values.duplicateKey) {
      this.db.getData(this.item.values.duplicateKey).then(data => {
        this.itemDuplicate.fromFB(data);
        this.db.bindItemUpdates(this.itemDuplicate).pipe(takeUntil(this.ngUnsubscribeDuplicate)).subscribe(() => {
          // this.fields = this.item.fields;
          this.itemDuplicate.values = mergeDeep({}, this.item.values);
          // TODO: only putback not changed values....
          this.itemDuplicate.loading = false;
          this._cd.markForCheck();
          this._cd.detectChanges();
        });
      });
    }
  }

  addProject() {
    const data = { ok: false, item: this.item };
    const dialogRef = this.dialog.open(DialogAddProjectComponent, {
      width: '400px',
      disableClose: true,
      data: data
    });

  }

  addBroker() {
    const data = { ok: false, item: this.item, brokerKey: null };
    const dialogRef = this.dialog.open(DialogAddBrokerComponent, {
      width: '400px',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(async () => {
      if (data.brokerKey) {
        this.brokerKey = data.brokerKey;
      }
    });
  }

  checkDuplicate() {
    this.backURL.addURL(`/contacts/${this.item.values.$key}`);
    const url = this.router.serializeUrl(this.router.createUrlTree([`/contacts/${this.item.values.duplicateKey}`]));
    window.open(window.location.origin + url, '_blank');
  }

  async mergeContact() {
    await this.db.mergeContact(this.item);
    // Option A — disable route reuse for this navigation so component is recreated
    const originalShouldReuse = this.router.routeReuseStrategy.shouldReuseRoute;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate(['/contacts', this.item.values.duplicateKey]).then(() => {
      // restore original strategy
      this.router.routeReuseStrategy.shouldReuseRoute = originalShouldReuse;
    });



    // Option B — force a full page reload after navigating
    // this.router.navigate(['/contacts', this.item.values.duplicateKey]).then(() => window.location.reload());
  }

  notDuplicate() {
    this.item.modifyData('notDuplicate', true);
    this.item.modifyData('duplicateKey', null);
    this.db.saveItem(this.item);
  }




}



@Component({
  selector: 'app-dialog-add-project',
  templateUrl: './add-project.component.html',
})
export class DialogAddProjectComponent extends MainComponent {

  public actionItem = new Action(null, this.setting);
  private _realtor = '';

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: ProjectService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public dialogRef: MatDialogRef<any>,
    public backURL: BackurlService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Project(null, setting);
    this.actionService = new ActionService(this.db.auth, this.db.afs, this.setting);

    // Set Default Agent & Agency...
    this.item.values.realtor = this.db.auth.uid;
    this._realtor = this.db.auth.uid;
    this.item.values.agency = this.db.auth.profile.values.agency ? this.db.auth.profile.values.agency : this.db.auth.profile.values.agencies ? this.db.auth.profile.values.agencies[0] : null;
    this.setting.setDynAgencies(this.item.values.realtor);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.data.item.values.$key) {
      if (!this.item.values.realtor) {
        this.item.values.realtor = this.db.auth.uid;
      }
      if (!this.item.values.agency) {
        this.item.values.agency = this.setting.getDefaultAgency(this.item.values.realtor);
      }
      // Check if realtor doing the new project
      let realtor = true;
      if (this.item.values.realtor !== this.db.auth.uid) {
        realtor = false;
      }

      if (realtor) {
        this.item.values.status = "discovery";
      } else {
        this.item.values.status = "new";
      }

      this.item.values.synaps = {
        contactsProjects: {
          [this.data.item.values.$key]: this.data.item.alias
        }
      }
      this.db.saveNewItem(this.item).then((newKey) => {
        this._createNewProjectAction(
          'newRequest',
          {
            projectType: this.item.values.type,
            originType: this.item.values.originType,
            origin: this.item.values.origin ? this.item.values.origin : this.item.values.originType,
            originMedium: this.item.values.originMedium,
            msg: this.item.values.originNote,
            referral: this.item.values.referral,
          },
          realtor ? true : false);
        if (realtor) {
          this._createNewProjectAction('accept', null, true);
          this._createNewProjectAction('discovery');
        }
        this.backURL.addURL(`/contacts/${this.data.item.values.$key}`);
        this.router.navigate([`/projects/${newKey}`]);
        this.dialogRef.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  public touched() {
    // Check if realtor has changed, if Yes reset select agency...
    if (this._realtor !== this.item.values.realtor) {
      this.setting.setDynAgencies(this.item.values.realtor);
      this.setting.show = false;
      this.item.values.agency = null;
      this._realtor = this.item.values.realtor;
    }
  }

  private _createNewProjectAction(type: string, data: any = {}, done: boolean = false) {
    this.actionItem.resetItem();
    Object.assign(this.actionItem.values, {
      type: type,
      date: new Date(),
      data: data,
      done: done,
      doneDate: done ? new Date() : null,
      realtor: this.item.values.realtor,
      agency: this.item.values.agency,
      synaps:
        { projectsActions: { [this.item.values.$key]: this.db.createAlias(this.item) } },
    });

    this.actionService.saveNewItem(this.actionItem);
  }


}




@Component({
  selector: 'app-dialog-add-broker',
  templateUrl: './add-broker.component.html',
})
export class DialogAddBrokerComponent extends MainComponent {

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: BrokerService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public dialogRef: MatDialogRef<any>,
    public backURL: BackurlService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Broker(null, setting);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.data.item.values.$key && (this.data.item.module === 'contacts' || this.data.item.module === 'companies')) {

      if (this.data.item.module === 'contacts') {
        this.item.values.synaps = {
          contactBroker: {
            [this.data.item.values.$key]: this.data.item.alias
          }
        }
      } else if (this.data.item.module === 'companies') {
        this.item.values.synaps = {
          companyBroker: {
            [this.data.item.values.$key]: this.data.item.alias
          }
        }
      }
      this.db.saveNewItem(this.item).then(() => {
        this.data.brokerKey = this.item.values.$key;
        this.setting._initBrokers();
        this.dialogRef.close();
      });
    } else {
      this.dialogRef.close();
    }
  }


}